exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._27ZQinvanYmm-boCPpy4bm{margin:0 0 8px;margin:0 0 .5rem;font-size:1.25em;font-weight:400}._2ApQ4LYKlT0JoO0a6O8dFN{width:100%;border:1px solid #78909c;line-height:1.4;padding:.3em .5em;border-radius:.3em;margin-bottom:1em;font-size:1em}._3FecnM8T0KKTbgDxqdYLKW{background-color:#ffd54f}._3yoO21RjjaY2s9X6mTe0Lj{background-color:#f48f42}._3RGub0j4OaGu2c3NL2JUTT{margin-bottom:0}._3Y2QbjgQWP2wbd-nE0YtiD{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._3gw4bheY3JGaAj6Dj2lqWF,._228poPuHmori2f2KZctkEl{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}._228poPuHmori2f2KZctkEl{margin-right:8px;margin-right:.5rem}._3gw4bheY3JGaAj6Dj2lqWF{margin-left:8px;margin-left:.5rem}", ""]);

// exports
exports.locals = {
	"Header": "_27ZQinvanYmm-boCPpy4bm",
	"Input": "_2ApQ4LYKlT0JoO0a6O8dFN",
	"Highlight": "_3FecnM8T0KKTbgDxqdYLKW",
	"Active": "_3yoO21RjjaY2s9X6mTe0Lj",
	"Footer": "_3RGub0j4OaGu2c3NL2JUTT",
	"Row": "_3Y2QbjgQWP2wbd-nE0YtiD",
	"FirstColumn": "_228poPuHmori2f2KZctkEl",
	"SecondColumn": "_3gw4bheY3JGaAj6Dj2lqWF"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1!./~/cssnext-loader!./src/Highlighter.example.css
// module id = 276
// module chunks = 0